import styled from 'styled-components';
import * as fonts from 'view/styles/fonts';
import { ThemedLink } from 'view/common/themed-link';
import { ExternalThemedLink } from 'view/common/external-themed-link';
import { token } from '@atlaskit/tokens';
import { colors } from '@atlaskit/theme';

export const RootLink = styled(ThemedLink)`
    ${fonts.h200};
    margin: 0;
`;

export const ExternalLink = styled(ExternalThemedLink)`
    ${fonts.h200};
    margin: 0;
`;

export const LinkSeperator = styled.span`
    color: ${token('color.text', colors.N800)};
    padding: 0 ${token('space.100', '8px')};
`;
